import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Loader2, BookOpen } from 'lucide-react';
import MotoShell from '../components/MotoShell';
import { api } from '../lib/api';

export default function MotoEtmPage() {
  const [dossiers, setDossiers] = useState(null);

  useEffect(() => {
    document.title = 'Le programme ETM — 9 dossiers officiels | Code 2 Roues';
    api.motoCatalog().then((d) => setDossiers(d.dossiers)).catch(() => setDossiers([]));
  }, []);

  return (
    <MotoShell>
      <section className="max-w-7xl mx-auto px-4 lg:px-6 pt-10 sm:pt-14" data-testid="moto-etm-page">
        <div className="text-[10.5px] uppercase tracking-[0.22em] text-sky-400 font-bold font-mono-spec mb-2">Code moto · Programme officiel 2026</div>
        <h1 className="font-serif-editorial text-[30px] sm:text-5xl leading-[1.05] max-w-3xl">Les 9 thèmes de l&apos;ETM, façon magazine.</h1>
        <p className="text-white/60 text-[13.5px] sm:text-[15px] mt-3 max-w-2xl leading-relaxed">
          L&apos;Épreuve Théorique Moto décortiquée en 9 numéros pédagogiques + articles satellites. Chaque dossier suit le programme officiel.
        </p>
        {!dossiers ? (
          <div className="py-24 flex justify-center"><Loader2 className="animate-spin text-sky-400" size={28} /></div>
        ) : (
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {dossiers.map((d) => (
              <Link key={d.slug} to={`/moto/apprendre/${d.slug}`} data-testid={`moto-dossier-card-${d.slug}`}
                className="group rounded-2xl overflow-hidden border border-white/10 bg-[#0b0f1a] hover:border-sky-500/40 transition-colors flex flex-col">
                <div className="h-36 overflow-hidden shrink-0 relative">
                  <img src={d.heroImage} alt={d.title} loading="lazy" className="w-full h-full object-cover opacity-75 group-hover:opacity-95 group-hover:scale-105 transition duration-500" />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-sky-500 text-black text-[11px] font-bold font-mono-spec">N°{d.issueNumber}/{d.totalIssues}</span>
                </div>
                <div className="p-4 flex-1 flex flex-col">
                  <div className="text-sky-300 text-[10px] font-mono-spec uppercase tracking-widest font-bold">{d.category}</div>
                  <div className="font-serif-editorial text-white text-[19px] leading-snug mt-1.5 group-hover:text-sky-200 transition-colors">{d.title}</div>
                  <p className="text-white/50 text-[12px] leading-snug mt-2 line-clamp-3 flex-1">{d.subtitle}</p>
                  <div className="mt-3 flex items-center gap-3 text-white/35 text-[11px] font-mono-spec">
                    <span className="inline-flex items-center gap-1.5"><Clock size={11} /> {d.readTimeMin} min</span>
                    <span className="inline-flex items-center gap-1.5"><BookOpen size={11} /> {d.satelliteCount} satellites</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </MotoShell>
  );
}
